<template lang="pug">
    .header-container
        .pc
            img.logo(src="@/assets/img/logo.png", @click="handleHome")
            .nav-container
                router-link.nav-item(v-for="(item, index) in list", :class='$route.path == item.path ? "active" : ""' :to="item.path" :key="index") {{item.label}}
        .m
            img.logo(src="@/assets/img/logo.png", @click="handleHome")
            img.menu(src="@/assets/img/menu.svg", @click="show = true")
            .cover-menu(v-if="show", @click="show = false")
                .close
                    img(src="@/assets/img/close-x.svg")
                router-link.menu(v-for="(item, index) in list", :class='$route.path == item.path ? "active" : ""' :to="item.path" :key="index") {{item.label}}
</template>

<script>
export default {
    name: 'Header',
    data() {
        return {
            show: false,
            list: [
                {
                    label: '公司简介',
                    path: '/company'
                },
                {
                    label: '核心团队',
                    path: '/team'
                },
                {
                    label: '投资案例',
                    path: '/case'
                },
                {
                    label: '新闻动态',
                    path: '/news'
                },
                {
                    label: '招纳贤士',
                    path: '/job'
                },
                {
                    label: '联系我们',
                    path: '/contact'
                }
            ]
        }
    },
    methods: {
        handleHome() {
            this.$router.replace({ path: '/home'})
        }
    }
}
</script>

<style lang="sass" scoped>
.header-container
    .pc
        display: none
    .m
        display: flex
        align-items: center
        justify-content: space-between
        height: 60px
        padding: 0 20px
        width: 100%
        box-sizing: border-box
        position: fixed
        z-index: 8
        top: 0
        left: 0
        background-color: #fff
        .logo
            width: 160px
        .cover-menu
            height: 100vh
            width: 100%
            position: fixed
            z-index: 4
            top: 0
            left: 0
            background-color: #fff
            display: flex
            align-items: center
            justify-content: center
            flex-direction: column
            box-sizing: border-box
            .close
                border: 4px solid #aaa
                margin-bottom: 2em
                border-radius: 50%
                height: 3em
                width: 3em
                display: flex
                justify-content: center
                align-items: center
                cursor: pointer
                &:active
                    opacity: 0.3
            .menu
                font-size: 26px
                font-weight: bold
                text-decoration: none
                color: #2d292a
                padding: 0.5em
            .active
                color: #c40000
@media screen and (min-width: 1024px)
    .header-container
        .m
            display: none
        .pc
            width: 100%
            display: flex
            align-items: center
            height: 100px
            position: fixed
            z-index: 8
            top: 0
            left: 0
            background: #fff
            box-sizing: border-box
            .logo
                margin-left: 2em
                width: 240px
                cursor: pointer
            .nav-container
                display: flex
                justify-content: flex-end
                flex: 1
                .nav-item
                    cursor: pointer
                    margin-right: 4em
                    text-decoration: unset
                    color: #2d292a
                    font-weight: bold
                    &::after
                            content: ''
                            width: 0em
                            display: block
                            bottom: 0
                            height: 2px
                            background: #c40000
                            position: absolute
                            left: 50%
                            transform: translateX(-50%)
                    &:hover
                        color: #c40000
                        transition: all 1s
                        position: relative
                        &::after
                            content: ''
                            width: 4em
                            display: block
                            bottom: 0
                            height: 2px
                            background: #c40000
                            position: absolute
                            transition: all 1s
                            left: 50%
                            transform: translateX(-50%)
                .active
                    color: #c40000
                    transition: all 1s
                    position: relative
                    &::after
                        content: ''
                        width: 4em
                        display: block
                        bottom: 0
                        height: 2px
                        background: #c40000
                        position: absolute
                        transition: all 1s
                        left: 50%
                        transform: translateX(-50%)
    
</style>